var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.376 11.106c-.084-.039-.272-.04-.272.136v3.315a.198.198 0 00.273.175 1.978 1.978 0 000-3.626zM14.583 5h3.25a.208.208 0 00.148-.356L13.689.354a.208.208 0 00-.356.146v3.25A1.25 1.25 0 0014.583 5zM10 10.936a.73.73 0 00-.73.729v2.5a.73.73 0 001.46 0v-2.498a.73.73 0 00-.73-.731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.833h-3.542A2.083 2.083 0 0112.5 3.75V.207A.208.208 0 0012.292 0H3.333a1.667 1.667 0 00-1.666 1.667v16.666A1.667 1.667 0 003.333 20h13.334a1.667 1.667 0 001.666-1.667V6.04a.208.208 0 00-.208-.207zM4.583 15.936a.52.52 0 01-.52-.521v-5a.52.52 0 01.52-.52 3.02 3.02 0 010 6.04zm7.188-1.77a1.77 1.77 0 01-3.542 0v-2.5a1.77 1.77 0 113.542 0zm3.646.73a.52.52 0 010 1.041 3.02 3.02 0 110-6.041.52.52 0 010 1.041 1.98 1.98 0 100 3.959z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.e0081c34.svg";
export { ForwardRef as ReactComponent };